import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20warm%20golden%20and%20red%20abstract%20gradient%20background%20with%20subtle%20Chinese%20cloud%20patterns%2C%20elegant%20minimal%20style%2C%20smooth%20texture%2C%20auspicious%20atmosphere%2C%20warm%20glowing%20tones&width=1800&height=600&seq=kaiyun-cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-black/40"></div>

      <div className="relative z-10 max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">
          准备好开启您的好运之旅了吗？
        </h2>
        <p className="text-sm md:text-base text-background-100/80 mb-8">
          从今天开始，让开运 com 陪伴您的每一天，探索更多开运奥秘
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/lucky-items"
            className="px-8 py-3 rounded-full bg-accent-500 text-foreground-950 font-medium text-sm whitespace-nowrap hover:bg-accent-400 transition-colors cursor-pointer"
          >
            浏览幸运物推荐
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 font-medium text-sm whitespace-nowrap hover:bg-background-50/25 transition-colors cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}